<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Delegasi SKPD (LV-II)</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">

                                    <th class="text-center" style="width: 5%">Kode</th>
                                    <th class="text-center" style="width: 45%">Program/Kegiatan</th>
                                    <th class="text-center" style="width: 10%">Anggaran</th>
                                    <!-- <th class="text-center" style="width: 0%">Target</th> -->
                                    <th class="text-center" style="width: 30%">Pelaksana</th>
                                    <th class="text-center" style="width: 10%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <template v-for="data in list_data">
                                        <tr class="h_isitable cetak_col_kop" :key="data.renja_program_id">
                                            <td class="tabel_center">{{data.program_kode}}</td>
                                            <td class="tabel_center" colspan="5">{{data.program_nama}}</td>
                                        </tr>
                                        <template v-for="data1 in data.kegiatan">
                                            <tr class="h_isitable" :key="data1.kegiatan_id">
                                                <td class="tabel_center">{{data.program_kode}}.{{data1.kegiatan_kode}}</td>
                                                <td class="tabel_center">{{data1.kegiatan_nama}}</td>
                                                <td class="tabel_center">{{format_uang(data1.TOTAL)}}</td>
                                                <!-- <td class="tabel_center text-center" >xxxxx</td> -->
                                                <td class="tabel_center" >
                                                    <ul>
                                                        <template  v-for="data2 in data1.pejabat" >
                                                            <li :key="data2.jabatan_id" v-if="data2.jabatan_nama != null">
                                                                {{data2.jabatan_nama}}&nbsp; 
                                                                <!-- <button type="button" class="btn bg-orange btn-xs " title="Hapus Data">x</button> -->
                                                                <a href="javascript:void(0);" title="Hapus Data" @click="removeData(data2.sakip_delegasi_lv2_id)">
                                                                    <span class="label label-danger">X</span>
                                                                </a>    
                                                                
                                                            </li>
                                                        </template>
                                                    </ul>
                                                </td>
                                                <td class="tabel_center text-center" >

                                                    <!-- <button @click="selectData_setting(data1)" class="btn bg-light-blue btn-xs waves-effect" title="Pengaturan sasaran/indikator" data-toggle="modal" data-target="#m_pengaturan_indikator">
                                                        <i class="material-icons" >settings</i>
                                                    </button>
                                                    &nbsp; -->
                                                    <button @click="selectData(data1)" class="btn bg-light-green btn-xs waves-effect" title="Pilih Pejabat Pelaksana" data-toggle="modal" data-target="#m_edit_data">
                                                        <i class="material-icons" >account_box</i>
                                                    </button>

                                                </td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>
                        </div>
                        <hr>

                        <!-- <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr> -->
                        <!-- ============================================================ MODAL ======================================================================== -->



                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PEJABAT PELAKSANA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA PELAKSANA</h4>
                                        </div>
                                        <form @submit.prevent="addData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Pejabat Pelaksana</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control selectku" v-model="form.jabatan_id">
                                                                    <option style="" v-for="data in list_jabatan" :key="data._id" :value="data._id">
                                                                        {{data.jabatan}}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Target</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.target" type="number" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="form.keterangan" class="form-control"></textarea>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PEJABAT PELAKSANA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST SASARAN INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_pengaturan_indikator" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">ATUR SARAN DAN INDIKATOR TRIWULAN</h4>
                                        </div>
                                        <form>
                                            <div class="modal-body">
                                                <button @click="getIndikator()" class="btn btn-primary" data-toggle="modal" data-target="#m_tambah_indikator" v-if="check_add_sasaran_indikator">Tambah Data</button>
                                                <hr>

                                                <div >
                                                    
                                                    <table class="table-kiken" width="100%">
                                                        <thead  class="bg-info kepala_table_f tabel_center" >
                                                            <tr>
                                                                <th width="5%" rowspan="2" class="text-center tabel_center">No</th>
                                                                <th width="30%" rowspan="2" class="text-center tabel_center">Sasaran/Indikator</th>
                                                                <th width="10%" rowspan="2" class="text-center tabel_center">Satuan</th>
                                                                <th width="10%" rowspan="2" class="text-center tabel_center">Target <br>Tahun Ini</th>
                                                                <th colspan="4" class="text-center tabel_center">Target</th>
                                                                <th width="5%" rowspan="2" class="text-center tabel_center">#</th>
                                                            </tr>
                                                            <tr>
                                                                <th width="10%" class="text-center">Triwulan I</th>
                                                                <th width="10%" class="text-center">Triwulan II</th>
                                                                <th width="10%" class="text-center">Triwulan III</th>
                                                                <th width="10%" class="text-center">Triwulan IV</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template  v-for="data in list_sasaran_indikator">
           
                                                                <tr :key="data.sasaran_id" class="cetak_col_kop">
                                                                    <td colspan="8">
                                                                        <strong>Sasaran : <i>{{data.sasaran_uraian}}</i></strong>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <button @click="selectDataSasaran(data)" class="btn btn-warning btn-xs waves-effect" title="Edit Sasaran" data-toggle="modal" data-target="#m_edit_sasaran">
                                                                            <i class="material-icons" >mode_edit</i>
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                                <template v-for="(data1, index1) in data.indikator">
                                                                    <tr :key="data1.renja_kegiatan_indikator_triwulan_id">
                                                                        <td class="text-center">{{index1+1}}</td>
                                                                        <td>{{data1.indikator_uraian}}</td>
                                                                        <td class="text-center">{{data1.indikator_satuan}}</td>
                                                                        <td class="text-center">{{data1.indikator_target_thn_ini}}</td>
                                                                        <td class="text-center">{{data1.tw1}}</td>
                                                                        <td class="text-center">{{data1.tw2}}</td>
                                                                        <td class="text-center">{{data1.tw3}}</td>
                                                                        <td class="text-center">{{data1.tw4}}</td>
                                                                        <td class="text-center">
                                                                            <button @click="selectDataindikator(data1)" class="btn btn-warning btn-xs waves-effect" title="Edit Indikator" data-toggle="modal" data-target="#m_edit_target_indikator">
                                                                                <i class="material-icons" >mode_edit</i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>


                                                        </tbody>
                                                    </table>
                                                </div>
                                                

                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="submit" class="btn btn-success waves-effect">TAMBAH</button> -->
                                                <button @click="exit_Indikator()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST SASARAN INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SASARAN INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_tambah_indikator" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="exit_Indikator()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">ATUR SARAN DAN INDIKATOR TRIWULAN</h4>
                                        </div>
                                        <form @submit.prevent="addSasaranIndikator()">
                                            <div class="modal-body">
                                               

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.uraian" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="sasaran.keterangan" class="form-control"></textarea>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                                <table class="table table-bordered" width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th width="5%" rowspan="2" class="text-center tabel_center">No</th>
                                                            <th width="35%" rowspan="2" class="text-center tabel_center">Indikator</th>
                                                            <th width="12%" rowspan="2" class="text-center tabel_center">Target <br>Tahun Ini</th>
                                                            <th colspan="4" class="text-center tabel_center">Target</th>
                                                        </tr>
                                                        <tr>
                                                            <th width="12%" class="text-center">Triwulan I</th>
                                                            <th width="12%" class="text-center">Triwulan II</th>
                                                            <th width="12%" class="text-center">Triwulan III</th>
                                                            <th width="12%" class="text-center">Triwulan IV</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="indikator.check">
                                                            <tr v-for="(data, index) in list_indikator" :key="data.renja_kegiatan_indikator_id">
                                                                <td class="text-center">{{index+1}}</td>
                                                                <td>{{data.uraian}}</td>
                                                                <td class="text-center">{{data.target_thn_ini}} {{data.satuan}}</td>
                                                                <td class="text-center"><input v-model="data.tw1" class="form-control" type="text" required/></td>
                                                                <td class="text-center"><input v-model="data.tw2" class="form-control" type="text" required/></td>
                                                                <td class="text-center"><input v-model="data.tw3" class="form-control" type="text" required/></td>
                                                                <td class="text-center"><input v-model="data.tw4" class="form-control" type="text" required/></td>
                                                            </tr>
                                                        </template>
                                                        <template>
                                                            <tr v-if="!indikator.check">
                                                                <td class="text-center" colspan="7">
                                                                    <div class="alert bg-teal">
                                                                        Data indikator kosong.. Silahkan meminta bantuan pada admin sakip anda untuk menginputkan data indikator pada form "Renja - Kegiatan" dalam Modul "e-Planing"
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </template>

                                                    </tbody>
                                                </table>

                                                <hr>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button @click="exit_Indikator()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SASARAN INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_edit_sasaran" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT SASARAN</h4>
                                        </div>
                                        <form @submit.prevent="addSasaranIndikator()">
                                            <div class="modal-body">

                                               <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="sasaran.uraian" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="sasaran.keterangan" class="form-control"></textarea>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SASARAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal" id="m_edit_target_indikator" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT TARGET INDIKATOR</h4>
                                        </div>
                                        <form @submit.prevent="addSasaranIndikator()">
                                            <div class="modal-body">

                                               <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Triwulan 1</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="indikator.tw1" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Triwulan 2</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="indikator.tw2" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Triwulan 3</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="indikator.tw3" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Triwulan 4</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="indikator.tw4" type="text" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>



<script>

    const ADD_URL = URL_APP+'api/v1/sakip_delegasi_lv2/';

    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';

    const URL_JABATAN = URL_APP+'api/v1/simpeg_jabatan/';



    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    jabatan_id : '',
                    target : 0,
                    keterangan : '',

                    renja_kegiatan_id : '',

                    renja_setup_id : '',
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',
                },
                sasaran : {
                    renja_kegiatan_sasaran_id : '',
                    renja_kegiatan_id : '',
                    uraian : '',
                    keterangan : '',
                },
                indikator : {
                    renja_kegiatan_indikator_triwulan_id : '',
                    renja_kegiatan_indikator_id : '',
                    renja_kegiatan_sasaran_id : '',
                    renja_kegiatan_id : '',
                    keterangan : '',
                    tw1 : 0,
                    tw2 : 0,
                    tw3 : 0,
                    tw4 : 0,
                    check : false,
                },
                arr_indikator : [],
                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',


                list_renja_setup :[],

                check_data_add : false,
                check_add_sasaran_indikator : false,
                list_data : [],
                page_first : 1 ,
                page_last : 0 ,
                cari_value : '',

                list_tahun : [],
                list_jabatan : [],
                list_indikator : [],
                list_sasaran_indikator : [],

                token : localStorage.token ,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;


            this.getDataTahun();
            this.getData();

            localStorage.sidemenu = 'sakip';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                console.log(this.unit_kerja);
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      renja_setup_id : this.form.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data;
                //   console.log(res_data);
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                console.log(data)
                this.form.renja_kegiatan_id = data.renja_kegiatan_id;
                this.form.renja_setup_id = data.renja_setup_id;
                this.form.tahun = data.tahun;
                this.form.instansi_id = data.instansi_id;
                this.form.unit_kerja = data.unit_kerja;

                this.getDataTahun();
                this.getJabatan();
            },
            selectData_setting : function(data){
                this.sasaran.renja_kegiatan_id = data.renja_kegiatan_id;
                this.getSasaranIndikator();
            },
            removeData : function(id){
                console.log(id);
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_jabatan = []
            },

        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data)
                    this.list_renja_setup = res_data;

                    if (res_data.length <= 0) {
                        // this.form.renja_setup_id = '';
                        // this.check_data_add = false;
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.getData();
                    }

                    // console.log(res_data[0]);



                })
            },
            getJabatan : function(){
                fetch(URL_JABATAN+'get_jabatan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    // console.log(res_data);
                    this.list_jabatan = res_data;
                })
            },
            getIndikator : function(){
                fetch(ADD_URL+'getIndikator', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        renja_kegiatan_id : this.sasaran.renja_kegiatan_id
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    if (res_data.length <= 0) {
                        console.log('data kosong');
                        this.indikator.check = false;
                    } else {
                        console.log(res_data);
                        this.indikator.check = true;
                        this.list_indikator = res_data;
                    }
                })
            },
            addSasaranIndikator : function(){
                // console.log(this.list_indikator);
                // console.log(this.sasaran)
                fetch(ADD_URL+'createIndikatorSasaran', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        list_indikator : this.list_indikator,
                        sasaran : this.sasaran
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getSasaranIndikator();
                })
            },
            getSasaranIndikator : function(){
                fetch(ADD_URL+'getSasaranIndikator', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        renja_kegiatan_id : this.sasaran.renja_kegiatan_id
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    // console.log(res_data);

                    if (res_data.length <= 0) {
                        console.log('data kosong');
                        this.check_add_sasaran_indikator = true;
                    } else {
                        this.check_add_sasaran_indikator = false;
                        this.list_sasaran_indikator = res_data

                    }
                })
            },
            selectDataindikator: function(data){
                console.log(data);
                this.indikator.renja_kegiatan_indikator_triwulan_id = data.renja_kegiatan_indikator_triwulan_id;
                this.indikator.renja_kegiatan_indikator_id = data.renja_kegiatan_indikator_id;
                this.indikator.renja_kegiatan_id = data.renja_kegiatan_id;
                this.indikator.tw1 = data.tw1;
                this.indikator.tw2 = data.tw2;
                this.indikator.tw3 = data.tw3;
                this.indikator.tw4 = data.tw4;
             },

             selectDataSasaran: function(data){
                 console.log(data);
                this.sasaran.renja_kegiatan_sasaran_id = data.renja_kegiatan_sasaran_id;
                this.sasaran.uraian = data.sasaran_uraian;
                this.sasaran.keterangan = data.sasaran_keterangan;
             },
            exit_Indikator : function(){
                this.list_indikator = [];
                this.indikator.check = false;
                this.list_sasaran_indikator = [];
            },



        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.list_data = [];
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;


                this.form.instansi_id = obj.instansi_id;
                this.instansi_id = obj.instansi_id

                this.getDataTahun();
                console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear()-1,
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                }
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
